<template>
  <vue-form @submit="submit"
           :disabled="isFormDisabled"
           :form="form"
           :action="action"
           :status="status">
    <section class="form-section">
      <header>
        <h3>Famille</h3>
        <p>
            La famille permet de regrouper une catégorie de produits.
        </p>
      </header>
      <div>
        <form-group class="md:w-1/2" field="name" label="Nom">
          <vue-input placeholder="ex: Viennoiserie" id="name" v-model="form.name" :disabled="isFormDisabled"/>
        </form-group>
      </div>
    </section>
    <section class="form-section">
      <header>
        <h3>Trie des étiquettes</h3>
        <p>
            Déterminez la manière de trier le rapport des étiquettes, ce réglage est spécifique à la famille.
        </p>
      </header>
      <div>
        <form-group field="sort_labels_by" label="De quelle manière trier les étiquettes ?">
          <p class="-m-1">
            <vue-radio class="m-1" :label="null" v-model="form.sort_labels_by" :disabled="isFormDisabled">Par défaut</vue-radio>
            <vue-radio class="m-1" label="customer" v-model="form.sort_labels_by" :disabled="isFormDisabled">Par client</vue-radio>
          </p>
        </form-group>
      </div>
    </section>
    <section class="form-section" v-if="isUpdateForm && canDelete">
      <header>
        <h3>Zone de danger</h3>
        <p>
          La famille sera <strong>définitivement supprimée</strong> et ne pourra pas être restaurée.
          Les produits de cette famille se retrouveront sans famille.
        </p>
      </header>
      <div>
        <form-group label="Voulez-vous supprimer définitivement cette famille ?">
          <confirm-button @confirmed="destroy"
                          popover-type="popover-top-left sm:popover-right"
                          btn-class="btn-primary btn-outline"
                          btn-confirm-text="Supprimer"
                          :disabled="isFormDisabled"
                          :status="statusDestroy">Supprimer la famille</confirm-button>
        </form-group>
      </div>
    </section>
  </vue-form>
</template>

<script>
import Form from 'form-backend-validation';
import form from '../../mixins/form';

export default {
  mixins: [form],

  data() {
    return {
      form: new Form({
        name: '',
        sort_labels_by: null,
      }),
    };
  },
};
</script>